module.exports = __webpack_public_path__ + "static/media/yeehaw-heading.8bd1b3d0.svg";